import React, { useEffect, useRef, useState } from 'react';
import '../Allocation/Allocation.css';
import { fetchActiveEvent, uploadResultData } from '../../Services/Employees';
import ToggleSwitch from '../ToggleSwitch';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

const Result = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isPublished, setIsPublished] = useState(false);
  const [activeEvent, setActiveEvent] = useState({});
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  useEffect(() => {
    fetchActiveEvent()
      .then((response) => {
        const eventData = response.data[0]?.eventMaster;
        if (eventData) {
          setActiveEvent(eventData);
          setIsPublished(eventData.isPublished);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleChooseFile = () => {
    fileInputRef.current.click();
  };

  const handleUpload = () => {
    if (!selectedFile) {
      withReactContent(Swal).fire({ icon: 'warning', text: 'Please choose an Excel file.' });
      return;
    }
    if (!activeEvent.eventName) {
      withReactContent(Swal).fire({ icon: 'warning', text: 'Active event not found. Please configure an active event first.' });
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('event', activeEvent.eventName);

    setLoading(true);
    uploadResultData(formData)
      .then((response) => {
        withReactContent(Swal).fire({
          icon: 'success',
          text: response.data,
          allowOutsideClick: false,
        });
        setSelectedFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      })
      .catch((error) => {
        const message = error.response?.data || 'Error uploading result file';
        withReactContent(Swal).fire({
          icon: 'error',
          text: typeof message === 'string' ? message : 'Error uploading result file',
          allowOutsideClick: false,
        });
      })
      .finally(() => setLoading(false));
  };

  const togglePublishStatus = () => {
    setIsPublished((prevState) => !prevState);
  };

  return (
    <div className="card border-0" style={{ background: 'white' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px', paddingRight: '2%' }}>
        <ToggleSwitch
          label="Published"
          checked={isPublished}
          onChange={togglePublishStatus}
        />
      </div>
      <h5 style={{ textAlign: 'center', color: 'red' }}>
        Active Event <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{activeEvent.eventName || '-'}</span>
      </h5>
      <h3 style={{ textAlign: 'center' }}>Upload Employee Result</h3>
      <div className="excel-upload-container" style={{ marginBottom: '16%', marginTop: '2%' }}>
        <h2 className="upload-heading">Upload Result</h2>
        <div className="upload-btn-wrapper">
          <button type="button" className="upload-btn" onClick={handleChooseFile}>Choose File</button>
          <input
            type="file"
            accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            onChange={handleFileChange}
            ref={fileInputRef}
            className="file-input"
          />
        </div>
        {selectedFile && <p className="selected-file">Selected file: {selectedFile.name}</p>}
        <div style={{ marginTop: '10px' }}>
          <button type="button" onClick={handleUpload} className="upload-btn" disabled={loading}>
            {loading ? 'Uploading...' : 'Upload'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Result;
